import React from "react";

const ResendInviteModal = ({ inviteMethod, id, email }) => {
  return (
    <div className="modal fade" id={`resend-invite-modal-${id}`} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div>
            <h4 className="text-center mb-4">Invite will be send</h4>
            <p className="text-center text-small">
              Invite will be send to <strong>{email}</strong>.
              <br />
              Please confirm your action.
            </p>
            <div className="text-center mt-4">
              <button
                type="button"
                className="btn btn-main"
                data-dismiss="modal"
                onClick={() =>
                  inviteMethod.mutate({
                    id: id,
                  })
                }
              >
                Resend
              </button>
              <button
                type="button"
                className="btn btn-sm btn-cancel"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ResendInviteModal.propTypes = {};

export default ResendInviteModal;
